import type { AlbumDocument } from "../lib/types.ts";
import { sortByLayer } from "../lib/geometry.ts";
import * as db from "../storage/indexeddb.ts";
import * as opfs from "../storage/opfs.ts";

/** Displayed page aspect (square); stored album.aspectRatio may still be older values. */
export const DISPLAY_ASPECT_RATIO = 1;

export function spreadIndices(pageIndex: number): { left: number; right: number } {
  const left = pageIndex - (pageIndex % 2);
  return { left, right: left + 1 };
}

export function isPortraitOrientation(): boolean {
  return window.matchMedia("(orientation: portrait)").matches;
}

export async function renderPage(
  pageEl: HTMLElement,
  album: AlbumDocument,
  pageIndex: number,
  interactive: boolean,
  selectedId: string | null = null,
): Promise<void> {
  const page = album.pages[pageIndex];
  if (!page) {
    pageEl.innerHTML = "";
    pageEl.style.aspectRatio = String(DISPLAY_ASPECT_RATIO);
    return;
  }
  pageEl.innerHTML = "";
  pageEl.style.aspectRatio = String(DISPLAY_ASPECT_RATIO);

  for (const placement of sortByLayer(page.placements)) {
    const asset = await db.getAsset(placement.assetId);
    if (!asset) continue;
    const url = await opfs.getObjectUrl(asset.variants.display.opfsPath);
    if (!url) continue;

    const photo = document.createElement("div");
    photo.className = `placement${selectedId === placement.id ? " selected" : ""}`;
    photo.style.left = `${placement.x * 100}%`;
    photo.style.top = `${placement.y * 100}%`;
    photo.style.width = `${placement.width * 100}%`;
    photo.style.height = `${placement.height * 100}%`;
    photo.style.transform = `rotate(${placement.rotation}rad)`;
    photo.dataset.placementId = placement.id;

    const img = document.createElement("img");
    img.src = url;
    img.alt = asset.description ?? "Album photo";
    img.draggable = false;
    photo.appendChild(img);

    if (interactive && selectedId === placement.id) {
      const resize = document.createElement("button");
      resize.type = "button";
      resize.className = "handle resize";
      resize.dataset.handle = "resize-se";
      resize.setAttribute("aria-label", "Resize photo");
      const rotate = document.createElement("button");
      rotate.type = "button";
      rotate.className = "handle rotate";
      rotate.dataset.handle = "rotate";
      rotate.setAttribute("aria-label", "Rotate photo");
      photo.append(resize, rotate);
    }

    pageEl.appendChild(photo);
  }
}
